import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const caseStudies = [
  {
    title: 'Renewable Energy Initiative',
    location: 'East Africa',
    description: 'Mobilizing $50M for solar power projects across rural communities.',
    image: 'https://images.unsplash.com/photo-1497440001374-f658d8994ac3?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80'
  },
  {
    title: 'Sustainable Agriculture',
    location: 'West Africa',
    description: 'Supporting climate-smart farming practices through innovative financing.',
    image: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80'
  }
];

export default function CaseStudies() {
  return (
    <section className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl font-bold text-gray-900">Case Studies</h2>
          <p className="mt-4 text-xl text-gray-600">
            Real impact through innovative financial solutions
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {caseStudies.map((study, index) => (
            <motion.div
              key={study.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="group relative overflow-hidden rounded-xl shadow-lg"
            >
              <div className="aspect-w-16 aspect-h-9">
                <img
                  src={study.image}
                  alt={study.title}
                  className="object-cover w-full h-full group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="text-white">
                  <h3 className="text-xl font-semibold mb-2">{study.title}</h3>
                  <p className="text-gray-200 text-sm mb-2">{study.location}</p>
                  <p className="text-gray-300">{study.description}</p>
                </div>
                <button className="mt-4 inline-flex items-center text-white hover:text-green-300 transition-colors">
                  Learn more
                  <ArrowRight className="ml-2 h-4 w-4" />
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}